import React from "react";
import { Box, Flex, Heading, Text, Button } from "@chakra-ui/react";
import { ArrowForwardIcon } from "@chakra-ui/icons";

// A titled white card for a page section, with an optional "View all"-style link.
// Styles live in App.scss under .section-card.
export const SectionCard = ({ title, subtitle, icon, action, headingAs = "h2", children }) => (
  <Box as="section" className="section-card">
    <Flex className="section-card__header">
      <Flex alignItems="center" gap="3">
        <Box className="section-card__icon" aria-hidden="true">{icon}</Box>
        <Box>
          <Heading as={headingAs} className="section-card__title">{title}</Heading>
          {!!subtitle && <Text className="section-card__subtitle">{subtitle}</Text>}
        </Box>
      </Flex>
      {!!action && (
        <Button
          className="section-card__action"
          variant="ghost"
          leftIcon={action.icon}
          rightIcon={action.icon ? undefined : <ArrowForwardIcon />}
          onClick={action.onClick}
        >
          {action.label}
        </Button>
      )}
    </Flex>
    {children}
  </Box>
);
